import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-premium";
import GridExportMenu from "../common/GridExportMenu";
import { Box, Divider, Typography } from "@mui/material";
import { useAppTranslation } from "../../hooks/useAppTranslation";

type Props = {
  total: number;
  columns: any[];
  rows: any[];
  selectedRows: any[];
  selectedCount: number;
};

export default function VendorDocumentsToolbar({ total, columns, rows, selectedRows, selectedCount }: Props) {
  const { t } = useAppTranslation("common");

  return (
    <GridToolbarContainer sx={{ px: 2, py: 1.5 }}>
      {/* LEFT */}
      <Box sx={{ flex: 1 }}>
        <Typography variant="h6">{t("Dokumenty dostawcy")}</Typography>
        <Typography variant="caption" color="text.secondary">
          {t("Łącznie")}: {total}
        </Typography>
      </Box>

      {/* RIGHT */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>       
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <Divider orientation="vertical" flexItem />
        <GridExportMenu
          label="Eksport"
          fileName={`faktury_${new Date().toISOString().slice(0, 10)}`}
          excelOptions={{
            columnsStyles: {
              documentDate: { numFmt: "dd.mm.yyyy" },
              amountGross: { numFmt: "#,##0.00" },
            },
          }} 
        />
      </Box>
    </GridToolbarContainer>
  );
}
